<template>
    <div>
        <div id="hello-hello">

            <p style="display:inline;float: left;line-height: 22px;"><b>-订单列表</b></p>

            <div style="display:inline-block">
                <el-radio-group v-model="statusSearch" @input="searchByStatus">
                    <el-radio-button label="0">待排</el-radio-button>
                    <el-radio-button label="1">已排</el-radio-button>
                    <el-radio-button label="2">生产</el-radio-button>
                    <el-radio-button label="3">暂停</el-radio-button>
                    <el-radio-button label="4">产中停</el-radio-button>
                    <el-radio-button label="5">返工</el-radio-button>
                    <el-radio-button label="6">完成</el-radio-button>
                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </div>

            <div style="display:inline-block;width: 300px;">
                <el-input placeholder="请输入产品名称/客户" v-model="queryValue" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
                </el-input>
            </div>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0;">
                <el-button round @click="batchDelete">删除</el-button>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0;">
                <el-button round @click="exportExcel">导出</el-button>
                <span>-</span>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-button round @click="download">下载模板</el-button>
                <span>-</span>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-upload action="#" :http-request="uploadFile" :show-file-list="false">
                    <el-button round type="primary">批量导入</el-button>
                    <span>-</span>
                </el-upload>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="openDialog">新增</el-button>
                <span>-</span>
            </p>

        </div>

        <el-table :data="orderList" style="width: 2000px;" ref="plasticTable" highlight-current-row v-loading="loading"
            :element-loading-text="loadingText" @selection-change="handleSelectionChange">

            <el-table-column type="selection" width="45">
            </el-table-column>

            <el-table-column prop="orderCode" label="订单编号" width="140">
            </el-table-column>
            <el-table-column prop="orderCount" label="订单数量" width="100" align="center">
            </el-table-column>
            <el-table-column prop="customer" label="客户" width="100">
            </el-table-column>
            <el-table-column prop="salesman" label="业务员" width="80">
            </el-table-column>
            <el-table-column prop="productName" label="产品名称" width="200">
            </el-table-column>

            <el-table-column prop="specifications" label="规格" width="100">
            </el-table-column>

            <el-table-column prop="productWeight" label="产品重量" width="60" align="center">
                <template slot="header">
                    <el-tooltip class="item" effect="light" placement="top" content="克">
                        <span>产品重量</span>
                    </el-tooltip>
                </template>
            </el-table-column>

            <el-table-column prop="createdTime" label="下单日期" width="100">
            </el-table-column>
            <el-table-column prop="deliveryTime" label="交货日期" width="100">
            </el-table-column>

            <el-table-column prop="equipmentName" label="设备" width="100">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="60">
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="150">
            </el-table-column>

            <el-table-column prop="orderTypeStr" label="委外" width="50">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="170">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        更改
                    </el-button>
                    <!-- <el-button @click="deleteClick(scope.row)" type="danger" round size="small">
                        删除
                    </el-button> -->
                    <el-button @click="outsourceClick(scope.row)" type="primary" round size="small"
                        :disabled="scope.row.orderTypeStr == '是' && scope.row.status == '待排' ? false : true">
                        委外操作
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes, prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[6, 10, 14, 18]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-dialog title="订单详情" :visible.sync="dlgFormVisible" width="60%">
            <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">

                <el-row>
                    <el-col :span="8">
                        <el-form-item label="订单编号" required :label-width="formLabelWidth">
                            <el-input v-model="form.orderCode" autocomplete="off" style="width:220px"
                                disabled></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="订单数量" required :label-width="formLabelWidth">
                            <el-input-number v-model="form.orderCount" :step="1" :min="1"
                                style="width:220px"></el-input-number>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="客户" required :label-width="formLabelWidth" prop="customerAbbrev">

                            <el-select v-model="form.customerAbbrev" filterable remote reserve-keyword
                                placeholder="请输入关键字" :remote-method="searchCustomer" :loading="loading"
                                @change="cusChange" style="width:220px" :disabled="modifyDisable">
                                <el-option v-for="item in form.customerList" :key="item.value"
                                    :label="item.customerAbbrev" :value="item.customerId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="8">
                        <el-form-item label="业务员" required :label-width="formLabelWidth" prop="salesman">
                            <el-select v-model="form.salesman" placeholder="请选择" style="width:220px"
                                :disabled="modifyDisable">
                                <el-option v-for="item in form.empList" :key="item.value" :label="item.employeeName"
                                    :value="item.userId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="产品名称" required :label-width="formLabelWidth" prop="productName">

                            <el-select v-model="form.productName" filterable remote reserve-keyword placeholder="请输入关键字"
                                :remote-method="searchProduct" :loading="loading" style="width:220px"
                                :disabled="modifyDisable">
                                <el-option v-for="item in form.productList" :key="item.value" :label="item.productName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="委外" :label-width="formLabelWidth" prop="orderType">
                            <el-select v-model="form.orderType" placeholder="请选择" style="width:220px"
                                :disabled="modifyDisable">
                                <el-option v-for="item in form.orderTypeList" :key="item.value" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="8">
                        <el-form-item label="下单日期" required :label-width="formLabelWidth" prop="createdTime">
                            <el-date-picker v-model="form.createdTime" type="date" placeholder="选择日期"
                                :disabled="modifyDisable">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="交货日期" required :label-width="formLabelWidth" prop="deliveryTime">
                            <el-date-picker v-model="form.deliveryTime" type="date" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="生产车间" :label-width="formLabelWidth" prop="shopName">
                            <el-select v-model="form.shopId" placeholder="请选择" style="width:220px" @change="shopChange">
                                <el-option v-for="item in form.shopList" :key="item.value" :label="item.shopName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="8">
                        <el-form-item label="组" :label-width="formLabelWidth" prop="teamName">
                            <el-select v-model="form.teamId" placeholder="请选择" style="width:220px">
                                <el-option v-for="item in form.teamList" :key="item.value" :label="item.teamName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="16">
                        <el-form-item label="备注" :label-width="formLabelWidth">
                            <el-input v-model="form.remark" autocomplete="off" type="textarea"
                                style="width:570px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div style="width:350px;display: inline-block;"></div>

                <!-- <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:570px"></el-input>
                </el-form-item> -->
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="$event => addPlasticOrder('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

        <el-drawer title="委外详情" :visible.sync="drawerVisible" size="30%" style="text-align: left;">
            <div style="padding: 0 10px;">
                <p>产品名称</p>
                <el-input v-model="form.productName" autocomplete="off" disabled="true"></el-input>

                <p>委外判定</p>
                <el-radio-group v-model="outsourceR" @input="switchR">
                    <el-radio label="1">合格</el-radio>
                    <el-radio label="2">不合格</el-radio>
                </el-radio-group>
            </div>

            <div v-if="outsourceR == '2'" style="padding: 0 10px;">
                <p>巡检点</p>
                <el-select v-model="patrolPointId" placeholder="请选择巡检点" style="width:220px" @change="patrolChange">
                    <el-option v-for="item in patrolPointList" :key="item.value" :label="item.patrolPointName"
                        :value="item.id">
                    </el-option>
                </el-select>

                <p>巡检说明</p>
                <el-input v-model="patrolRemark" autocomplete="off" type="textarea" auto-focus></el-input>

                <p>上传图片</p>
                <el-upload class="avatar-uploader" action="#" :http-request="uploadImg" :show-file-list="false">

                    <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>

                <p><b>巡检项目</b></p>
                <div v-for="(item, index) in inspectionItemList" :key="index">

                    <p style="font-size: 15px; text-align: left;width:80%;margin-left: 10px;">{{ item.inspectionName }}
                    </p>

                    <div style="display:inline-block;margin: 5px;font-weight: bold;color: green;">

                        <el-radio-group v-model="item.status" @input="inspectionR">
                            <el-radio label="1">正常</el-radio>
                            <el-radio label="2">异常</el-radio>
                        </el-radio-group>

                    </div>
                </div>

            </div>

            <div style="position: absolute;bottom: 5px;right: 15px;">

                <el-button type="primary" @click="outsourceOrder">保 存</el-button>
            </div>

        </el-drawer>

    </div>
</template>

<script>
export default {
    name: "PlasticOrder",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),

            orderList: [],
            dlgFormVisible: false,

            statusSearch: 0,

            queryValue: '',
            form: {
                id: '',
                orderCode: '自动生成',
                orderCount: 1,

                customerList: [],
                customerId: '',
                customerAbbrev: '',

                empList: [],
                salesman: '',
                salesmanId: '',
                productList: [],
                productId: '',
                productName: '',

                orderType: 0,
                orderTypeList: [{
                    id: 0,
                    name: '否'
                }, {
                    id: 1,
                    name: '是'
                }],

                createdTime: new Date(),
                deliveryTime: '',
                status: 0,

                shopList: [],
                shopId: '',
                teamList: [],
                teamId: '',

                remark: ''
            },
            loading: false,
            modifyDisable: false,

            spendTime: 0,
            timer: null,

            formLabelWidth: '120px',

            multipleSelection: [],

            drawerVisible: false,
            outsourceR: '1',

            patrolPointList: [],
            patrolPointId: '',
            patrolRemark: '',

            imgFile: {},
            imgList: [],
            inspectionItemList: [],

            pageIndex: 0,
            pageNum: 6,
            total: 0,
            pageCount: 0,

            rules: {
                customerAbbrev: [
                    { required: true, message: '请选择客户', trigger: 'blur' },
                    { required: true, message: '请选择客户', trigger: 'change' }
                ],
                salesman: [
                    { required: true, message: '请输入业务员', trigger: 'blur' },
                    { required: true, message: '请输入业务员', trigger: 'change' }
                ],
                productName: [
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                    { required: true, message: '请输入产品名称', trigger: 'change' }
                ],
                createdTime: [
                    { required: true, message: '请选择下单日期', trigger: 'blur' },
                    { required: true, message: '请选择下单日期', trigger: 'change' }
                ],
                deliveryTime: [
                    { required: true, message: '请选择交货日期', trigger: 'blur' },
                    { required: true, message: '请选择交货日期', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        // 动态生成loading上显示的文字
        loadingText() {
            return `加载中，用时 ${this.spendTime} 秒`;
        }
    },
    methods: {
        handleSelectionChange(val) {
            // console.log('val')
            // console.log(val)
            this.multipleSelection = val
        },
        batchDelete() {

            var rows = this.multipleSelection

            if (rows) {
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    rows.forEach(row => {

                        this.removePlasticOrder(row)
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })

            }

        },
        exportExcel() {

            this.$axios({
                method: "post",
                url: "/shiro/plastic/order/excel",
                data: {
                    userId: this.userId,
                    statusStr: this.statusSearch,
                    queryParam: this.queryValue,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "订单导出.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        uploadFile(f) {
            this.loading = true
            this.spendTime=0

            this.timer = setInterval(() => {

                this.spendTime += 1
            }, 1000)

            const form = new FormData()

            form.append('uploadFile', f.file)

            form.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/plastic/order/upload",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg,
                    duration: 0,
                    showClose: true
                })

                if (data.status != 200) {

                    this.loading = false

                    clearInterval(this.timer)
                    this.timer = null
                    return
                }

                this.getAllOrder(this.statusSearch)
            })
        },
        download() {
            this.$axios({
                method: "get",
                url: "/shiro/plastic/order/download",
                data: {},
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "订单导入模板.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        getWorkTeam() {
            this.$axios({
                method: "post",
                url: "/shiro/work/team/shopId",
                data: {
                    workshopId: this.form.shopId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.form.teamList = data.data
            })
        },
        shopChange() {

            this.getWorkTeam()
        },
        getAllWorkshop() {
            this.$axios({
                method: "post",
                url: "/shiro/workshop/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.form.shopList = data.data

            })
        },
        searchOrder(query) {
            this.orderList = []
            this.pageIndex = 0

            if (this.queryValue !== '') {

                this.loading = true

                setTimeout(() => {
                    this.getAllOrder(this.statusSearch)
                }, 200)

            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        getBaseProductAll(val) {
            this.$axios({
                method: "post",
                url: "/shiro/base/product/getAll",
                data: {
                    queryParam: val,
                    status: 1,
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.productList = data.data
            })
        },
        searchProduct(val) {
            if (val !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false
                    this.getBaseProductAll(val)
                }, 200)

            }

        },
        // selectClick(selection, row) {

        //     this.$refs.plasticTable.clearSelection()
        //     this.$refs.plasticTable.toggleRowSelection(row)

        //     this.form.orderCode = row.orderCode
        // },
        // rowClick(row) {
        //     //console.log(row)
        //     this.$refs.plasticTable.clearSelection()
        //     this.$refs.plasticTable.toggleRowSelection(row)

        //     this.form.orderCode = row.orderCode
        // },
        uploadPatrolImg() {

            const form = new FormData()

            form.append('image', this.imgFile)
            form.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/patrol/record/upload",
                // name: 'image',
                headers: {
                    token: this.token
                },
                data: form
            }).then(result => {

                const data = result.data

                // console.log('uploadPatrolImg')

                // console.log(data)

                this.imgList.push(data)
            })
        },
        uploadImg(f) {

            this.imgFile = f.file

            this.uploadPatrolImg()
        },
        completeOrder() {

            this.$axios({
                method: "post",
                url: "/shiro/plastic/order/complete",
                data: {
                    completeCount: this.form.orderCount,

                    productName: this.form.productName,
                    id: this.form.id,
                    userId: this.userId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.drawerVisible = false

            })
        },
        addPatrolRecord() {

            this.$axios({
                method: "post",
                url: "/shiro/patrol/record/add",
                data: {
                    patrolPointId: this.patrolPointId,
                    remark: this.patrolRemark,

                    imgUrlList: this.imgList,
                    inspectionItemList: this.inspectionItemList,

                    orderId: this.form.id,
                    maker: this.userId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.drawerVisible = false
            })
        },
        outsourceOrder() {

            if (this.outsourceR == '1') {

                this.completeOrder()
            } else {

                if (this.imgList.length == 0) {

                    this.$message({
                        type: 'info',
                        message: '请先上传图片'
                    })
                    return
                }

                this.addPatrolRecord()
            }

        },
        patrolChange() {

            this.getAllInspectionItem()
        },
        getAllInspectionItem() {
            this.$axios({
                method: "post",
                url: "/shiro/base/process/inspection/getAll",
                data: {
                    baseProcessId: this.patrolPointId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                let data = result.data.data

                for (let i in data) {

                    data[i].status = '2'
                }

                this.inspectionItemList = data
            })
        },
        getAllPatrolPoint() {

            this.$axios({
                method: "post",
                url: "/shiro/patrol/point/getAll",
                data: {
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.patrolPointList = data.data
            })
        },
        inspectionR(val) {

            console.log(this.inspectionItemList)
        },
        switchR(val) {

            if (val == '2') {

                this.getAllPatrolPoint()
            }

        },
        outsourceClick(row) {
            this.form.id = row.id

            this.form.productName = row.productName

            this.form.orderCount = row.orderCount

            this.outsourceR = '1'

            this.patrolPointId = ''

            this.inspectionItemList = []

            this.drawerVisible = true
        },
        handleClick(row) {

            this.modifyDisable = true

            this.form.id = row.id

            this.form.orderCode = row.orderCode
            this.form.orderCount = row.orderCount

            this.form.customerAbbrev = row.customerId
            this.form.customerId = row.customerId

            this.getEmpAll()

            this.form.salesman = row.salesmanId

            this.form.productName = row.productId

            this.form.orderType = row.orderType

            this.form.createdTime = row.createdTime
            this.form.deliveryTime = row.deliveryTime
            this.form.status = null
            this.form.remark = row.remark

            this.dlgFormVisible = true
        },
        openDialog() {
            this.modifyDisable = false

            this.form.empList = []

            this.form.id = ''
            this.form.orderCode = '自动生成'
            this.form.orderCount = 1

            this.form.customerAbbrev = ''

            this.form.salesman = ''
            this.form.productName = ''

            this.form.createdTime = new Date()
            this.form.deliveryTime = ''
            this.form.status = 0
            this.form.remark = ''

            this.dlgFormVisible = true
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removePlasticOrder(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        getBaseCustomerAll(val) {
            this.$axios({
                method: "post",
                url: "/shiro/base/customer/getAll",
                data: {
                    queryParam: val,
                    typeStr: '1',
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.customerList = data.data
            })
        },
        searchCustomer(val) {

            if (val !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false

                    this.getBaseCustomerAll(val)
                }, 200)

            }
        },
        cusChange(value) {
            // console.log(value)

            this.form.customerId = value

            this.getEmpAll()
        },
        getEmpAll() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/get/customerId",
                data: {
                    customerId: this.form.customerId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.empList = data.data

            })
        },
        addPlasticOrder(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios({
                        method: "post",
                        url: "/shiro/plastic/order/add",
                        data: {
                            id: this.form.id,
                            orderCode: this.form.orderCode,
                            orderCount: this.form.orderCount,

                            customer: this.form.customerAbbrev,

                            salesman: this.form.salesman,
                            productName: this.form.productName,

                            orderType: this.form.orderType,

                            createdTime: this.form.createdTime,
                            deliveryTime: this.form.deliveryTime,
                            status: this.form.status,

                            teamId: this.form.teamId,
                            remark: this.form.remark,

                            companyId: this.companyId,
                            companyType: 0
                        }, headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        if (data.status != 200) {
                            this.$message(data.msg)
                            return
                        }

                        this.dlgFormVisible = false

                        this.getAllOrder(this.statusSearch)
                    })
                } else {
                    return false
                }
            })
        },
        searchByStatus(val) {
            this.pageIndex = 0

            this.getAllOrder(val)
        },
        removePlasticOrder(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/plastic/order/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAllOrder(this.statusSearch)
            })
        },
        getAllOrder(val) {

            this.loading = true

            const formData = new FormData()

            formData.append('userId', this.userId)

            formData.append('statusStr', val)
            formData.append('queryParam', this.queryValue)

            formData.append('companyId', this.companyId)
            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', this.pageNum)

            this.$axios({
                method: "post",
                url: "/shiro/plastic/order/all/user",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.orderList = data.data

                this.total = this.orderList.length > 0 ? this.orderList[0].total : 0

                for (let i in this.orderList) {
                    this.orderList[i].createdTime = this.$moment(this.orderList[i].createdTime).format("YYYY-MM-DD")
                    this.orderList[i].deliveryTime = this.$moment(this.orderList[i].deliveryTime).format("YYYY-MM-DD")

                    if (this.orderList[i].status == 0) {
                        this.orderList[i].status = '待排'
                    } else if (this.orderList[i].status == 1) {
                        this.orderList[i].status = '已排'
                    } else if (this.orderList[i].status == 2) {
                        this.orderList[i].status = '生产'
                    } else if (this.orderList[i].status == 3) {
                        this.orderList[i].status = '暂停'
                    } else if (this.orderList[i].status == 4) {
                        this.orderList[i].status = '产中停'
                    } else if (this.orderList[i].status == 5) {
                        this.orderList[i].status = '返工'
                    } else {
                        this.orderList[i].status = '完成'
                    }

                    if (this.orderList[i].orderType == 0) {
                        this.orderList[i].orderTypeStr = '否'
                    } else {
                        this.orderList[i].orderTypeStr = '是'
                    }
                }

                this.loading = false
            })
        },
        pageClick(currentPage) {
            this.orderList = []

            this.pageIndex = (currentPage - 1) * this.pageNum

            this.getAllOrder(this.statusSearch)
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAllOrder(this.statusSearch)
        },
    },
    mounted() {
        // console.log('PlasticOrder.vue--mounted()')

        this.setDefaultPath('/plasticOrder')

        this.getAllOrder(this.statusSearch)

        this.getBaseCustomerAll("")

        this.getAllWorkshop()
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

/* .DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
} */

.el-pagination__total {
    color: green;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
}

.el-radio input[aria-hidden="true"] {
    display: none !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}
</style>